import tingle from 'tingle.js';

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {String} selectorID - ID of the modal DOM element to clone
 * @return {Tingle} - https://robinparisi.github.io/tingle/
 */
const newModalFromSelector = (selectorID, footer, cssClass = [], onClose = null) => {
    // set optionts
    const modalOptions = {
        closeMethods: ['overlay', 'escape'],
        cssClass,
        onClose: () => {
            modal.destroy();
            if (typeof onClose === 'function') {
                onClose();
            }
        },
        onOpen: () => { $('html').addClass('html-tingle-enabled'); },
        beforeClose: () => {
            if ($('.tingle-modal.tingle-modal--visible').length < 2) {
                $('html').removeClass('html-tingle-enabled');
            }
            return true;
        }
    };
    if (footer) { modalOptions.footer = true; };

    // create modal
    const modal = new tingle.modal(modalOptions);

    // clone content
    if (selectorID) {
        const contentModal = document.getElementById(selectorID);
        if (contentModal) {
            modal.setContent(contentModal.innerHTML);
        }
    }

    return modal;
};

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {String} html - HTML string
 * @return {Tingle} - https://robinparisi.github.io/tingle/
 */
const newModalFromString = (html, footer, cssClass = [], onOpen, onClose) => {
    // set optionts
    const modalOptions = {
        closeMethods: ['overlay', 'button', 'escape'],
        cssClass,
        onClose: () => {
            modal.destroy();
            if (typeof onClose === 'function') {
                onClose();
            }
        },
        onOpen: () => {
            $('html').addClass('html-tingle-enabled');
            if (typeof onOpen === 'function') {
                onOpen();
            }
        },
        beforeClose: () => {
            if ($('.tingle-modal.tingle-modal--visible').length < 2) {
                $('html').removeClass('html-tingle-enabled');
            }
            return true;
        }
    };
    if (footer) { modalOptions.footer = true; };

    // create modal
    const modal = new tingle.modal(modalOptions);

    // add content
    if (html) {
        modal.setContent(html);
    }

    return modal;
};

/**
 * This function creates a modal starting from supplied options
 * @return {Tingle} - https://robinparisi.github.io/tingle/
 */
const newModalWithOptions = (modalOptions) => {
    return new tingle.modal(modalOptions);
};

/**
 * This class creates a modal without copying or moving any HTML,
 * but simply showing and hiding an existing Node.
 * This is to avoid problems with manipulated elements such as Google Maps
 */
class ModalShowHide {
    constructor (selector = '', newModalType, toPropagateClick, classToPreventHide) {
        this.$el = $(selector);
        this.selector = selector;
        this._scrollposition = 0;
        this.toPropagateClick = toPropagateClick;
        this.classToPreventHide = classToPreventHide;
        if (newModalType) {
            this.isOpenTypeCustom = false;
        } else {
            this.isOpen = false;
        }

        this.events();
    }

    show (newModalType) {
        if (newModalType) {
            if (this.isOpenTypeCustom) {
                return;
            }
            this.isOpenTypeCustom = true;
        } else {
            if (this.isOpen) {
                return;
            }
            this.isOpen = true;
        }

        // mimic tingle scroll lock
        this._scrollPosition = window.pageYOffset;
        if (this.$el.hasClass('tingle-override')) {
            // do nothing
        } else {
            $('body').addClass('tingle-enabled');
            $('html').addClass('html-tingle-enabled');
            $('body').css('top', -this._scrollPosition + 'px');
            this.$el.parent('.tingle-modal').addClass('tingle-modal--visible');
        }
    }

    hide (newModalType) {
        if (newModalType) {
            if (!this.isOpenTypeCustom) {
                return;
            }
            this.isOpenTypeCustom = false;
        } else {
            if (!this.isOpen) {
                return;
            }
            this.isOpen = false;
        }

        // mimic tingle scroll lock
        if ($('.tingle-modal.tingle-modal--visible').length < 2) {
            $('body').removeClass('tingle-enabled');
            $('html').removeClass('html-tingle-enabled');
            window.scrollTo(0, this._scrollPosition);
            $('body').css('top', null);
        }
        this.$el.parent('.tingle-modal').removeClass('tingle-modal--visible');
    }

    events () {
        $('body').on('click', '.tingle-modal', (e) => {
            if (e.target.className === '') {
                return;
            }
            if ($(e.target).hasClass('tingle-modal') || !$(e.target).closest(this.classToPreventHide)) {
                var newModalType = $(e.target).data('modalType') || null;
                this.hide(newModalType);
                e.stopPropagation();
            }
        });
        $('body').on('click', '.modal-close', (e) => {
            var newModalType = $(e.target).data('modalType') || null;
            this.hide(newModalType);
            e.stopPropagation();
        });

        if (!this.toPropagateClick) {
            $('body').on('click', this.selector, (e) => {
                e.stopPropagation();
            });
        }
    }
};
export {
    newModalFromSelector,
    newModalFromString,
    newModalWithOptions,
    ModalShowHide
};
